export default function Footer({ t, agent }) {
  const websiteHost = agent.website
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, "");
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A0A0A] text-white/60 py-12 border-t border-white/10"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div>
            <img
              src="/brand/c21-gold.png"
              alt="Century 21"
              className="h-12 w-auto mb-4"
            />
            <p className="text-sm font-[Barlow_Semi_Condensed]">
              Belo Horizonte Residences
              <br />
              Avenida Belo Horizonte, Setúbal
            </p>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#BEAF87] font-[Barlow_Semi_Condensed] mb-4">
              Contacto
            </div>
            <ul className="space-y-2 text-sm font-[Barlow_Semi_Condensed]">
              <li>{agent.name}</li>
              <li>
                <a href={`tel:${agent.phone}`} className="hover:text-[#BEAF87]">
                  {agent.phoneDisplay}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${agent.email}`}
                  className="hover:text-[#BEAF87]"
                >
                  {agent.email}
                </a>
              </li>
              <li>
                <a
                  href={agent.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#BEAF87]"
                >
                  {websiteHost}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#BEAF87] font-[Barlow_Semi_Condensed] mb-4">
              Legal
            </div>
            <p className="text-xs font-[Barlow_Semi_Condensed] leading-relaxed">
              {t.footer.disclaimer}
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs font-[Barlow_Semi_Condensed]">
          <span>
            © {new Date().getFullYear()} Century 21 · {t.footer.rights}
          </span>
          <span className="text-white/40">
            Belo Horizonte Residences · Setúbal, Portugal
          </span>
        </div>
      </div>
    </footer>
  );
}
